import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  CHANGE_ORG_STATUS,
  DELETE_ORGANISATIONS,
  GET_ORGANISATIONS,
  RESTORE_ORGANISATION,
} from "URLRoutes";
import { generateURLOptions } from "URLOptions";
import Swal from "sweetalert2";
import BusinessCard from "./BusinessCard";
import CommonTextField from "components/common/CommonTextField";
import EditOrganisationModal from "./Modals/EditOrganisationModal";

const Businesses = () => {
  const [businesses, setBusinesses] = useState([]);

  const [selectedFilter, setSelectedFilter] = useState("all");
  const [filtered, setFiltered] = useState(null);

  const [search, setSearch] = useState("");

  const [selectedBusiness, setSelectedBusiness] = useState(null);
  const [showEdit, setShowEdit] = useState(false);

  useEffect(() => {
    document.title =
      "Organisations & Groups | Administration Panel | Mind Pulse";
    getOrganisations();
  }, []);

  useEffect(() => {
    getOrganisations();
  }, [search]);

  useEffect(() => {
    if (selectedFilter == "all") {
      setSelectedFilter("all");
      setFiltered(null);
    } else if (selectedFilter == "heart") {
      setFiltered(businesses?.filter((business) => !business?.companyPlan));
    } else if (selectedFilter == "core") {
      setFiltered(
        businesses?.filter(
          (business) => business?.companyPlan?.name == "Mind Pulse Core",
        ),
      );
    } else if (selectedFilter == "expand") {
      setFiltered(
        businesses?.filter(
          (business) => business?.companyPlan?.name == "Mind Pulse Expand",
        ),
      );
    } else if (selectedFilter == "optimum") {
      setFiltered(
        businesses?.filter(
          (business) => business?.companyPlan?.name == "Mind Pulse Optimum",
        ),
      );
    }
  }, [selectedFilter]);

  const getOrganisations = async () => {
    try {
      const response = await axios.get(
        GET_ORGANISATIONS + (search.length > 0 ? search : "all"),
        {
          headers: generateURLOptions(),
        },
      );
      if (response?.data?.success === false) {
        alert(response?.data?.message ?? "");
        return;
      }
      console.log("Organisations Response: ", response.data.data);
      setBusinesses(response?.data?.data);
    } catch (error) {
      console.error("Get Organisations Error: ", error);
      alert(error);
    }
  };

  const deleteOrganisation = async (id) => {
    try {
      const response = await axios.post(
        DELETE_ORGANISATIONS,
        {
          organisationId: id,
        },
        {
          headers: generateURLOptions(),
        },
      );
      if (response?.data?.success === false) {
        alert(response?.data?.message ?? "");
        return;
      }

      getOrganisations();
    } catch (error) {
      console.error("Delete Organisations Error: ", error);
      alert(error);
    }
  };

  const restoreOrganisation = async (id) => {
    try {
      const response = await axios.post(
        RESTORE_ORGANISATION,
        {
          organisationId: id,
        },
        {
          headers: generateURLOptions(),
        },
      );
      if (response?.data?.success === false) {
        alert(response?.data?.message ?? "");
        return;
      }

      getOrganisations();
    } catch (error) {
      console.error("Restore Organisations Error: ", error);
      alert(error);
    }
  };

  const changeOrganisationStatus = async (id) => {
    try {
      const response = await axios.post(
        CHANGE_ORG_STATUS,
        {
          organisationId: id,
        },
        {
          headers: generateURLOptions(),
        },
      );
      if (response?.data?.success === false) {
        alert(response?.data?.message ?? "");
        return;
      }

      getOrganisations();
    } catch (error) {
      console.error("Organisation Status Error: ", error);
      alert(error);
    }
  };

  const deleteBusinessItem = (id) => {
    Swal.fire({
      title: "Delete Organisation",
      text: "Deleting an Organisation is irreversible, Organisation data, along with it's members' data is held onto for 90 days in accordance with local laws. Please confirm you want to delete this item.",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Delete Organisation",
    }).then(async (result) => {
      if (result.isConfirmed) {
        deleteOrganisation(id);
      }
    });
  };

  return (
    <>
      <EditOrganisationModal
        isOpen={showEdit}
        onClose={() => {
          setShowEdit(false);
          getOrganisations();
        }}
        organisation={selectedBusiness}
      />
      <div className="w-full px-8">
        {/* Heading Area */}
        <div className="flex flex-row mt-8">
          <div className="flex flex-col">
            <h4 className="font-medium text-lg">Organisations & Groups</h4>
            <p className="font-light text-base">
              {filtered ? (filtered?.length ?? 0) : (businesses?.length ?? 0)}{" "}
              Groups
            </p>
          </div>

          <div style={{ flex: 1 }} />

          {/* Options Row */}
          <div className="flex flex-row justify-center items-center">
            {/* All */}
            <div
              onClick={() => setSelectedFilter("all")}
              className={
                selectedFilter == "all"
                  ? "border-[#5153F5] bg-[#5153F5] text-white border px-6 rounded-full mr-2"
                  : "text-[#5153F5] border-[#5153F5] border px-6 rounded-full mr-2"
              }
            >
              <p className="text-base font-medium ">All</p>
            </div>

            {/* Heart */}
            <div
              onClick={() => setSelectedFilter("heart")}
              className={
                selectedFilter == "heart"
                  ? "border-[#5153F5] bg-[#5153F5] text-white border px-6 rounded-full mr-2"
                  : "text-[#5153F5] border-[#5153F5] border px-6 rounded-full mr-2"
              }
            >
              <p className="text-base font-medium ">Heart</p>
            </div>

            {/* Core */}
            <div
              onClick={() => setSelectedFilter("core")}
              className={
                selectedFilter == "core"
                  ? "border-[#5153F5] bg-[#5153F5] text-white border px-6 rounded-full mr-2"
                  : "text-[#5153F5] border-[#5153F5] border px-6 rounded-full mr-2"
              }
            >
              <p className="text-base font-medium ">Core</p>
            </div>

            {/* Expand */}
            <div
              onClick={() => setSelectedFilter("expand")}
              className={
                selectedFilter == "expand"
                  ? "border-[#5153F5] bg-[#5153F5] text-white border px-6 rounded-full mr-2"
                  : "text-[#5153F5] border-[#5153F5] border px-6 rounded-full mr-2"
              }
            >
              <p className="text-base font-medium ">Expand</p>
            </div>

            {/* Optimum */}
            <div
              onClick={() => setSelectedFilter("optimum")}
              className={
                selectedFilter == "optimum"
                  ? "border-[#5153F5] bg-[#5153F5] text-white border px-6 rounded-full"
                  : "text-[#5153F5] border-[#5153F5] border px-6 rounded-full"
              }
            >
              <p className="text-base font-medium ">Optimum</p>
            </div>
          </div>

          <div style={{ flex: 1 }} />
          <div className="w-1/3">
            <CommonTextField
              placeholder={"Search for an Organisation or Group"}
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
        </div>

        {/* Render Users */}
        <div className="grid grid-cols-1 md:grid-cols-3 xl:grid-cols-4 3xl:grid-cols-5 gap-2 mt-2">
          {filtered
            ? filtered?.map((user) => (
                <BusinessCard
                  key={user?._id}
                  item={user}
                  onDelete={deleteBusinessItem}
                  onRestore={restoreOrganisation}
                  onChangeStatus={changeOrganisationStatus}
                  onEdit={(data) => {
                    setSelectedBusiness(data);
                    setShowEdit(true);
                  }}
                />
              ))
            : businesses?.map((user) => (
                <BusinessCard
                  key={user?._id}
                  item={user}
                  onDelete={deleteBusinessItem}
                  onRestore={restoreOrganisation}
                  onChangeStatus={changeOrganisationStatus}
                  onEdit={(data) => {
                    setSelectedBusiness(data);
                    setShowEdit(true);
                  }}
                />
              ))}
        </div>
      </div>
    </>
  );
};

export default Businesses;
